import { InboxClinicLogo } from '@agentic-flow-studio/shared/components/inbox-clinic-logo';
import { AcceptInvitePage } from '@agentic-flow-studio/shared/components/invite/AcceptInvitePage';
import { inviteAuthPath } from '@agentic-flow-studio/shared/lib/invite-links';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authClient } from '@/utils/betterAuth';

export default function AcceptInvite() {
  const { data: session } = authClient.useSession();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  return (
    <AcceptInvitePage
      brandName="Inbox Clinic"
      logo={<InboxClinicLogo className="h-8 w-8" />}
      currentUserEmail={session?.user.email}
      onSwitchAccount={() => {
        authClient.signOut();
        navigate(inviteAuthPath('login', token));
      }}
    />
  );
}
